export default __webpack_public_path__ + "static/media/edo_bead.2a4c72ee.png";